module.exports = __webpack_public_path__ + "static/media/04_tn.0981dc16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/04_tn.jpg
// module id = 434
// module chunks = 0